import MainLayout from '@/components/layout/MainLayout';
import LandingLayout from '@/components/layout/LandingLayout';
import * as routeConstants from '@/router/constants';

import {
  Moves,
  Devices,
  CreateDevice,
  EditDevice,
  MovesCalendar,
  Login,
  Settings,
  DeviceDetails,
  DevicesCalendar
} from '@/views';

export default [
  {
    path: routeConstants.LOGIN_URL,
    name: 'Login',
    component: Login,
    meta: {
      layout: LandingLayout,
      title: 'Login',
      requiresAuth: false,
    },
  },
  {
    path: routeConstants.SETTINGS_URL,
    name: 'Settings',
    component: Settings,
    meta: {
      layout: MainLayout,
      title: 'Settings',
      requiresAuth: true,
    },
  },
  {
    path: routeConstants.DASHBOARD_URL,
    name: 'Devices',
    component: Devices,
    meta: {
      layout: MainLayout,
      title: 'Devices',
      requiresAuth: true,
    },
  },
  {
    path: routeConstants.DEVICE_DETAILS_URL,
    name: 'DeviceDetails',
    component: DeviceDetails,
    meta: {
      layout: MainLayout,
      title: 'Device Details',
      requiresAuth: true
    }
  },
  {
    path: routeConstants.EDIT_DEVICE_URL,
    name: 'EditSingleDevice',
    component: EditDevice,
    meta: {
      layout: MainLayout,
      title: 'Edit Device',
      edit: true,
      requiresAuth: true,
    },
  },
  {
    path: routeConstants.NEW_DEVICE_URL,
    name: 'NewSingleDevice',
    component: CreateDevice,
    meta: {
      layout: MainLayout,
      title: 'New Device',
      edit: false,
      requiresAuth: true,
    },
  },
  {
    path: routeConstants.DEVICES_CALENDAR_URL,
    name: 'DeviceCalendar',
    component: DevicesCalendar,
    meta: {
      layout: MainLayout,
      title: 'Devices Calendar',
      requiresAuth: true,
    },
  },
  {
    path: routeConstants.MOVES_URL,
    name: 'Moves',
    component: Moves,
    meta: {
      layout: MainLayout,
      title: 'Moves',
      requiresAuth: true,
    },
  },
  {
    path: routeConstants.MOVES_CALENDAR_URL,
    name: 'MovesCalendar',
    component: MovesCalendar,
    meta: {
      layout: MainLayout,
      title: 'Moves Calendar',
      requiresAuth: true,
    },
  },
  {path: '*', redirect: routeConstants.DASHBOARD_URL},
];